// Author YuJiaBei
// Date 2021-01-13 09:43:53

class SithMesMstShiftRule {
constructor({
        id = null,
        name = '',
        ruleType = '',
        loopRule = '',
        switchingCycle = '',
        beginTime = '',
        eachShiftDuration = '',
        eachShiftRatedWorkingHours = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.ruleType = ruleType;
    this.loopRule = loopRule;
    this.switchingCycle = switchingCycle;
    this.beginTime = beginTime;
    this.eachShiftDuration = eachShiftDuration;
    this.eachShiftRatedWorkingHours = eachShiftRatedWorkingHours;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstShiftRule();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ruleType',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.ruleType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '节假日休息' },
                            { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'loopRule',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.loopRule',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'switchingCycle',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.switchingCycle',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'beginTime',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.beginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eachShiftDuration',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.eachShiftDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eachShiftRatedWorkingHours',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.eachShiftRatedWorkingHours',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftRule.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    ruleTypeFilter : "",
    loopRuleFilter : "",
    eachShiftRatedWorkingHoursFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstShiftRule.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ruleTypeFilter',
        label: 'label.sith.mst.sithMesMstShiftRule.filter.ruleType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '节假日休息' },
                { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'loopRuleFilter',
        label: 'label.sith.mst.sithMesMstShiftRule.filter.loopRule',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eachShiftRatedWorkingHoursFilter',
        label: 'label.sith.mst.sithMesMstShiftRule.filter.eachShiftRatedWorkingHours',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'ruleType',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.ruleType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,required: true
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '节假日休息' },
                { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'loopRule',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.loopRule',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'switchingCycle',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.switchingCycle',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'beginTime',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.beginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
            ,required: true
                }
        },
        {
        key: 'eachShiftDuration',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.eachShiftDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'eachShiftRatedWorkingHours',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.eachShiftRatedWorkingHours',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftRule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstShiftRule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
